import React from 'react'

export function PickUpDetails() {

    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">

                            <div className="col-md-12">

                                <div className="row">
                                    <div className="col-lg-4 col-md-6 mb-3">
                                        <div className="card p-3 h-100">
                                            <div className="text-center ">
                                                <div className="iconImg mx-auto my-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shop" viewBox="0 0 16 16">
                                                        <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z" />
                                                    </svg>
                                                </div>
                                                <h5 className="mb-0">Retailer Name</h5>
                                            </div>
                                            <hr />
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Customer Name - </td>
                                                        <td className="py-1">Lorem Ipsum</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Mobile No. - </td>
                                                        <td className="py-1">+919898959898</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Retailer No. - </td>
                                                        <td className="py-1">+919898959898</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>



                                    </div>

                                    <div className="col-lg-4 col-md-6 mb-3">
                                        <div className="card p-3 h-100">

                                            <div className="text-center ">
                                                <div className="iconImg mx-auto my-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-truck" viewBox="0 0 16 16">
                                                        <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                    </svg>
                                                </div>
                                                <h5 className="mb-0">Delviery Info.</h5>
                                            </div>
                                            <hr />
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Job No. - </td>
                                                        <td className="py-1">Lorem Ipsum</td>
                                                    </tr><tr>
                                                        <td className="py-1"> Pick Up - </td>
                                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success"> Retailer Delivery</span> </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Transport Vendor Name - </td>
                                                        <td className="py-1">Lorem Ipsum</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="card p-3 h-100">

                                            <div className="text-center ">
                                                <div className="iconImg mx-auto my-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-seam" viewBox="0 0 16 16">
                                                        <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                                    </svg>
                                                </div>
                                                <h5 className="mb-0">Pickup Info</h5>
                                            </div>
                                            <hr />
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Name Pick Up Location - </td>
                                                        <td className="py-1">Indore</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Local Delivery Warehouse - </td>
                                                        <td className="py-1">Lorem Ipsum</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Pick Up Date - </td>
                                                        <td className="py-1">30 ,may</td>
                                                    </tr> <tr>
                                                        <td className="py-1">Comments - </td>
                                                        <td className="py-1">Lorem Ipsum</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    {/* <hr /> */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card p-3">
                                <div className="row">
                                    <ul className="nav mb-3 mt-0 tablist profiletab" id="pills-tab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link active" id="pills-cargodtls-tab" data-bs-toggle="pill" data-bs-target="#pillscargodtls" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/package.svg" /><span className="showondesk">Cargo Details</span></a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="tab-content " id="pills-tabContent">
                                    <div className="tab-pane fade active show" id="pillscargodtls" role="tabpanel">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr className="lh-sm">
                                                            <th>No. of Packages</th>
                                                            <th>Weight </th>
                                                            <th>Dimension<br />( L x W x H cms)</th>
                                                            <th> Description</th>
                                                            <th>Total Volume</th>
                                                            <th>Total Weight</th>
                                                            <th>Additional Packing Required</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td> 98 </td>
                                                            <td> 9Kg </td>
                                                            <td> 127cm </td>
                                                            <td> lurem Goods </td>
                                                            <td> 98 </td>
                                                            <td> 98kg </td>
                                                            <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Yes</span> </td>
                                                        </tr>
                                                        <tr>
                                                            <td> 98 </td>
                                                            <td> 9Kg </td>
                                                            <td> 127cm </td>
                                                            <td> lurem Goods </td>
                                                            <td> 98 </td>
                                                            <td> 98kg </td>
                                                            <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Yes</span> </td>
                                                        </tr>
                                                        <tr>
                                                            <td> 98 </td>
                                                            <td> 9Kg </td>
                                                            <td> 127cm </td>
                                                            <td> lurem Goods </td>
                                                            <td> 98 </td>
                                                            <td> 98kg </td>
                                                            <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Yes</span> </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </div >

    )
}
